var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 16,
    viewBox: "0 -960 960 960",
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-71.87q-84.674 0-159.109-32.217T191.261-191.5q-55.196-55.196-87.294-129.75T71.869-480.478q0-84.674 32.098-158.989 32.098-74.316 87.294-129.392 55.195-55.076 129.63-87.174Q395.326-888.131 480-888.131t159.109 32.098q74.435 32.098 129.63 87.174 55.196 55.076 87.294 129.392 32.098 74.315 32.098 158.989T856.033-321.25q-32.098 74.554-87.294 129.75-55.195 55.196-129.63 87.413Q564.674-71.869 480-71.869Zm0-91q132.565 0 224.848-92.402 92.282-92.402 92.282-225.206 0-51.848-16.304-100.174-16.304-48.326-47.63-89.37L290.218-227.283q40.565 31.805 89.13 48.109Q427.913-162.87 480-162.87ZM226.565-290.935l442.739-442.978q-41.043-31.087-89.25-47.152Q531.848-797.13 480-797.13q-132.565 0-224.848 92.043-92.282 92.044-92.282 224.609 0 51.848 16.304 100.174 16.304 48.326 47.391 89.369Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.cb92b47ac5a4f6f615c0e3982c6c3d7c.svg";
export { ForwardRef as ReactComponent };